import { NotificationWizard } from "./CreateNotificationWizard/index";
import InAppNotificationSettings from "./inApp/InAppNotificationSettings";
import { NotificationSettings } from "./NotificationSettings";

const NotificationCenter = ({ pageId }) => (
  <>
    {pageId === "notifications" && <NotificationSettings />}
    {(pageId === "notifications:create" || pageId === "notifications:edit") && <NotificationWizard />}
    {pageId === "notifications:in-app" && <InAppNotificationSettings />}
  </>
);

export default NotificationCenter;
